import * as Types from '../constants/Types';

export const getCoupon = (couponCode, typeProduct, idProduct, quantity) => ({ type: Types.GET_COUPON, couponCode, typeProduct, idProduct, quantity });
export const setCoupon = (couponData) => ({ type: Types.SET_COUPON, couponData });

export const clearCoupon = () => ({ type: Types.CLEAR_COUPON })


